import { Component, Vue, Prop } from 'vue-property-decorator';
import LoaderCard from "@/components/loader-card/LoaderCard";
@Component<MiProgressLinear>({
  components: {
    LoaderCard,
  },
})
export default class MiProgressLinear extends Vue {
  @Prop()
  protected value!: string;

  public mounted() {
    //
  }
}
